export default "__VITE_ASSET__T54DThbe__"